import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';

/**
 * SelectModalPanel
 */
class SelectModalPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      checkedList: this.props.checkedList,
      isAllChecked: false
    };
    this.handleMakerSelect = this.handleMakerSelect.bind(this);
    this.handleMakerSelectAll = this.handleMakerSelectAll.bind(this);
    this.handleApply = this.handleApply.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  /**
   * リストアイテムチェックイベント
   */
  handleMakerSelect(targetId) {
    let tempList = commonLogic.deepCopy(this.state.checkedList);
    const index = tempList.indexOf(targetId);

    if (index != -1) {
      tempList.splice(index, 1);

      const allCheckIndex = tempList.indexOf(0);
      if (allCheckIndex != -1) {
        this.setState({ isAllChecked: false });
      }
    } else {
      tempList.push(targetId);
    }

    if (tempList.length == this.props.masterList.length) {
      this.setState({ isAllChecked: true });
    } else {
      this.setState({ isAllChecked: false });
    }

    this.setState({ checkedList: tempList });
  }

  /**
   * リストアイテムチェックイベント(すべて)
   */
  handleMakerSelectAll() {
    let tempList = commonLogic.deepCopy(this.state.checkedList);
    if (tempList.length == this.props.masterList.length) {
      this.setState({ checkedList: [], isAllChecked: false });
    } else {
      tempList = [];
      tempList = this.props.masterList.map(item => item[this.props.idKey]);
      this.setState({ checkedList: tempList, isAllChecked: true });
    }
  }

  /**
   * 確定ボタン押下
   */
  handleApply() {
    const checkedList = commonLogic.deepCopy(this.state.checkedList);
    this.props.handleModalShowChange(checkedList);
    // $('#modal_select_panel').hide();
  }

  /**
   * キャンセルボタン押下
   */
  handleCancel() {
    this.setState({ checkedList: [], isAllChecked: false });
    this.props.handleModalShowChange();
    // $('#modal_select_panel').hide();
  }

  render() {
    const idKey = this.props.idKey;
    const valueKey = this.props.valueKey;

    // 表示データを生成
    const nodes = this.props.masterList.map((item) => {

      return (
        <label className="modal_select_list_row">
          <input type="checkbox" checked={this.state.checkedList.includes(item[idKey])} className="modal_select_checkbox" onChange={() => this.handleMakerSelect(item[idKey])} />
          <p value={item} key={item[idKey]}>{item[valueKey]}</p>
        </label>
      );
    });

    return (
      <div className="modal_select_panel_top">
        <div className="modal_select_panel_parent">
          <div className="modal_select_panel_header">
            <span>{this.props.modalTitle}</span>
          </div>

          <div className="modal_select_content">
            <div className="modal_select_content_inner">

              <label className="modal_select_list_row">
                <input type="checkbox" checked={this.state.isAllChecked || this.state.checkedList.length == this.props.masterList.length} className="modal_select_checkbox" onChange={() => this.handleMakerSelectAll()} />
                <p value={0} key={0}>{this.props.allCheckText}</p>
              </label>

              {nodes}
            </div>
          </div>

          <div className="modal_select_panel_footer">
            <div className="modal_select_panel_footer_content">
              <div className="modal_select_panel_reset content_item_border_default" onClick={() => this.handleCancel()}>
                <span>
                  キャンセル
                </span>
              </div>
              <div className="modal_select_panel_apply content_item_border_default" onClick={() => this.handleApply()}>
                <span>
                  確定
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

SelectModalPanel.propTypes = {
  masterList: PropTypes.any.isRequired,
  checkedList: PropTypes.any.isRequired,
};

export default SelectModalPanel;
